import React from 'react'

export default props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" {...props}>
    <path
      d="M91.2 44.07c0-16.43-18.62-29.7-41.6-29.7S8 27.68 8 44.07c0 9.43 6.13 17.83 15.7 23.27-2.18 7.75-5.53 10.54-8.45 13.83-.7.84-1.5 1.53-1.26 2.7h0a2.15 2.15 0 0 0 2.23 1.77 40.4 40.4 0 0 0 5.3-1 51.06 51.06 0 0 0 21.33-11.22 64.78 64.78 0 0 0 6.74.37c23 0 41.6-13.28 41.6-29.72"
      fill="#545454"
    />
    <path
      d="M41.1 29.4a3.05 3.05 0 0 1-3.28 3 3.06 3.06 0 1 1 0-6.12 3 3 0 0 1 3.28 3.12zm-6.28 25V34.84h6.08V54.4zM45.8 41.08l-.16-6.24h5.28l.28 2.68h.12a7.16 7.16 0 0 1 6-3.12c4 0 7 2.64 7 8.4v11.6h-6.04V43.56c0-2.52-.88-4.24-3.08-4.24a3.25 3.25 0 0 0-3.08 2.28 4.18 4.18 0 0 0-.24 1.52V54.4H45.8z"
      fill="#fff"
    />
  </svg>
)
